<template>
  <b-card class="mb-0 h-100">
    <a
      :href="item.contentUrl"
      target="_blank"
    >
      <div
        :style="{ backgroundImage: 'url(' + item.contentImageUrl + ')' }"
        class="catalog-image text-center mb-2 mx-auto"
        :alt="item.contentName"
      />
      <b-card-title class="mb-1">
        {{ item.contentName }}
      </b-card-title>
    </a>
    <p class="mb-50 metadata-txt">
      <span>
        {{ $tk('ClientPortal.CatalogItem.Id') }}:
      </span>
      <span class="text-secondary">{{ item.contentId }}</span>
    </p>
    <p
      v-for="metadata in item.metadata"
      :key="metadata.key"
      class="mb-50 metadata-txt"
    >
      <span>
        {{ metadata.key }}:
      </span>
      <span class="text-secondary">{{ metadata.value }}</span>
    </p>
  </b-card>
</template>

<script>

export default {
  props: {
    item: Object,
  },
}
</script>

<!-- Create new scss file if you add more than two classes inside component -->
<style lang="scss" scoped>
.catalog-image {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 120px;
    max-width: 160px;
}
</style>
